import { useRef } from "react";
import "../App.css";

interface SelectProps {
  label: string;
  value: number;
  current: number;
  onSelect: (value: number) => void;
  small?: boolean; // smaller text, for options sharing a row
}

// A sticker angle: 1.5 to 3.5 degrees. Given the previous angle it always
// tips the other way, so two in a row never lean the same direction.
export const randomTilt = (prev?: string) => {
  const sign = prev
    ? parseFloat(prev) > 0
      ? -1
      : 1
    : Math.random() < 0.5
      ? -1
      : 1;
  return `${sign * (1.5 + Math.random() * 2)}deg`;
};

// The last option picked anywhere, so the next pick leans the other way
let lastPickTilt: string | undefined;
const pickTilt = () => {
  lastPickTilt = randomTilt(lastPickTilt);
  return lastPickTilt;
};

// Full-width option button. The selected one becomes a pink sticker, slapped
// on at a new random angle each time it is picked.
export const Select: React.FC<SelectProps> = ({
  label,
  value,
  current,
  onSelect,
  small = false,
}) => {
  const selected = current === value;
  const tilt = useRef<string | null>(null);
  const wasSelected = useRef(false);
  if (selected && !wasSelected.current) tilt.current = pickTilt();
  wasSelected.current = selected;

  return (
    <div
      className={`setting-option ${small ? "button-text-s" : "button-text-m"}${
        selected ? " is-selected" : ""
      }`}
      style={{ "--tilt": tilt.current ?? undefined } as React.CSSProperties}
      role="radio"
      aria-checked={selected}
      onClick={() => onSelect(value)}
    >
      {label}
    </div>
  );
};

export default Select;
